/**
 * AutocompleteZones
 * 
 * @Author: Focci
 * @Date: 2023-09-27 12:23:41
 * @Last Modified by: Focci
 * @Last Modified time: 2023-09-27 12:23:41
 */

import PropTypes from 'prop-types'
import SVGHandle from '@img/handle.svg'
import { useCallback, useState } from 'react'
import { ButtonBase } from '@comp/material'
import { useTranslations } from 'next-intl'
import { useCombine } from '../context'
import ZoneAndSchool from '../zone-school/index'

export function ZoneButton({
  single,
  className = 'p-2 border-y',
  ...props 
}) {
  const ts = useTranslations('search')

  return (
    <div className={className}>
      <ButtonBase 
        className="w-full"
        // onClick={() => setOpen(true)}
        {...props}
      >
        <div 
          className="
            py-1 px-3 flex items-center justify-left gap-2 w-full rounded-sm text-f.8
            bg-[#e8f5fe] text-primary hover:bg-primary hover:text-white transition-colors"
        >
          <SVGHandle width=".7rem" />
          <span className="text-f.8 font-medium">
            {single ? ts('district') : ts('selectDistrictSchool')}
          </span>
        </div>
      </ButtonBase>
    </div>
  )
}

export default function AutocompleteZones({
  single,
  onSubmit = () => {}
}) {
  const { keyword } = useCombine()
  const [open, setOpen] = useState(false)

  const handleSubmit = useCallback(({ data }) => {
    setOpen(false)
    onSubmit({ data })
  }, [onSubmit])

  if(keyword) {
    return null
  }

  return (
    <>
      <ZoneButton single={single} onClick={() => setOpen(true)} />
      {open && (
        <ZoneAndSchool
          open={open}
          single={single}
          onClose={() => setOpen(false)}
          onSubmit={handleSubmit}
        />
      )}
    </>
  )
}

AutocompleteZones.propTypes = {
  single: PropTypes.bool,
}
